
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./analytics_extension": () => {
return Promise.all([__webpack_require__.e("2957"), __webpack_require__.e("2569"), __webpack_require__.e("3351"), __webpack_require__.e("9401"), __webpack_require__.e("5020")]).then(() => (() => (__webpack_require__(2073))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };